<template>
  <div class="results-main-view">
    <modal
      ref="xmlModal"
      template="loading"
      title="Aguarde"
      ref-name="xmlModal"
    >
      <p>Gerando XML...</p>
    </modal>

    <subheader class="alternative-subheader">
      <div
        slot="filter-labels"
        @click="pushToFilter()"
      >
        <h2>
          Resultados
          <span
            v-for="(filterLabel, index) in filterLabels"
            :key="filterLabel"
          >
            <span class="filter-labels">{{ filterLabel }}</span><span v-if="index + 1 < filterLabels.length">, </span>
          </span>
        </h2>
      </div>
      <div class="subheader-actions-container">
        <div
          class="subheader-actions-container__turn-back"
          @click="pushToFilter()"
        >
          <md-icon md-src="/static/images/icon-back-to-search.svg" />
        </div>
        <button
          id="btnExport"
          :disabled="!hasResults"
          class="btn btn-primary btn-regular-size"
          @click="exportXml(resultsSelected)"
        >
          <md-icon
            md-src="/static/images/icon-download-arrow.svg"
            class="icon-download"
          />Exportar
        </button>
      </div>
    </subheader>

    <results-list
      v-if="hasResults || resultsLoading"
      :selected.sync="resultsSelected"
    />

    <div
      v-else
      class="empty-cart"
    >
      <img
        src="/static/images/icon-empty-cart.svg"
        alt="Não existem resultados disponíveis de acordo com a busca realizada."
      >
      <h2>Não existem resultados disponíveis de acordo com a busca realizada.</h2>
    </div>
  </div>
</template>

<script>
import SubHeader from '../common/SubHeader'
import ResultsList from './ResultsList'
import EmptyCart from '../common/EmptyCart'
import { mapActions, mapGetters } from 'vuex'
import notify from '../../api/notification'
import strings from '../../strings'
import { formartDateFromArray } from '@/utils/date-utils'
import { convertArrayFilterToLabel, convertDateToLabel } from '@/utils/build-filter-labels'
import Moment from 'moment'

export default {
  name: 'ResultsMainView',
  components: {
    subheader: SubHeader,
    'results-list': ResultsList,
    'empty-cart': EmptyCart
  },
  data: () => ({
    resultsSelected: [],
    filterOptions: strings.resultsFilter,
    originOptions: strings.originResultsFilter,
    filterLabels: []
  }),
  computed: {
    ...mapGetters(['resultLoadingStatus', 'hasResults', 'resultList', 'resultsLoading', 'showXmlModal', 'getTodayDate', 'resultBreakStatus', 'resultHasHourSelected', 'profile', 'toggle']),
    today: function () {
      return formartDateFromArray(this.getTodayDate)
    }
  },
  watch: {
    resultLoadingStatus: function (newValue) {
      if (newValue === 'STATUS_FAILED' && !this.resultBreakStatus) {
        notify({
          title: 'AVISO:',
          message: 'Erro ao carregar informações. Por favor, tente novamente.',
          action: {
            title: 'RECARREGAR',
            handler: this.reload
          }
        })
      }
    },
    showXmlModal: function (showXml) {
      if (showXml) {
        this.$refs.xmlModal.open()
      } else {
        this.$refs.xmlModal.close()
      }
    },
    $route(to, from) {
      this.selectResultList(this.$route.query)
    }
  },
  beforeDestroy() {
    this.clearAllResultData()
    this.resultsSelected = []
  },
  mounted() {
    this.selectResultList(this.$route.query)
    this.buildFilterLabel()
  },
  created() {
    this.updateToday()

    this.$analytics.pushAnalyticsEvent('vpageview', {
      page: 'results/list',
      'id-usuario': this.profile.id,
      'id-lab': this.profile.id_laboratory,
      nlab: this.profile.laboratoryName
    })
  },
  methods: {
    ...mapActions(['clearAllResultData', 'selectResultList', 'xmlResults', 'updateToday']),
    pushToFilter() {
      this.$router.push({ path: '/results/filter', query: this.$route.query })
    },
    reload() {
      window.location.reload()
    },
    exportXml(resultsSelected) {
      this.xmlResults(resultsSelected).then(downloadLink => {
        if (downloadLink) {
          document.body.appendChild(downloadLink)
          downloadLink.click()
          this.clearAllResultData()
          this.submitEventToAnalytics({
            action: 'Exportar Resultados Selecionados',
            label: resultsSelected.length
          })
        }
      })
    },
    filterInitial() {
      if (this.$route.query.orderBy || this.$route.query.orderBy === '') {
        return strings.resultsFilter.filter(options => options.value === this.$route.query.orderBy)[0]
      } else {
        return strings.resultsFilter.filter(options => options.value === 'false')[0]
      }
    },
    filterInitialOrigin() {
      if (this.$route.query.filterByOrigin || this.$route.query.filterByOrigin === '') {
        return strings.originResultsFilter.filter(
          originOptions => originOptions.value === this.$route.query.filterByOrigin
        )[0]
      } else {
        return strings.originResultsFilter.filter(originOptions => originOptions.value === 'true')[0]
      }
    },
    filterInitialStartDate() {
      if (this.$route.query.startDate || this.$route.query.startDate === '') {
        if (this.resultHasHourSelected) {
          return Moment(this.$route.query.startDate).format('DD/MM/YYYY HH:mm')
        } else {
          return Moment(this.$route.query.startDate).format('DD/MM/YYYY')
        }
      } else {
        return this.today
      }
    },
    filterInitialEndDate() {
      if (this.$route.query.endDate || this.$route.query.endDate === '') {
        if (this.resultHasHourSelected) {
          return Moment(this.$route.query.endDate).format('DD/MM/YYYY HH:mm')
        } else {
          return Moment(this.$route.query.endDate).format('DD/MM/YYYY')
        }
      } else {
        return this.today
      }
    },
    buildFilterLabel() {
      this.filterLabels = []
      this.filterLabels.push(convertDateToLabel(this.filterInitialStartDate(), this.filterInitialEndDate(), this.today))
      if (this.$route.query.filterByOrigin !== '' && this.$route.query.filterByOrigin !== undefined) {
        this.filterLabels.push(convertArrayFilterToLabel(this.$route.query.filterByOrigin, strings.originResultsFilter))
      }
      if (this.$route.query.orderBy !== '' && this.$route.query.orderBy !== undefined) {
        this.filterLabels.push(convertArrayFilterToLabel(this.$route.query.orderBy, strings.resultsFilter))
      }
      if (this.$route.query.patientName) {
        this.filterLabels.push('paciente ' + this.$route.query.patientName)
      }
      if (this.$route.query.codeOsLis) {
        let labelName = this.toggle.covax ? 'Requisition Number ' : 'OS LIS '
        this.filterLabels.push(labelName + this.$route.query.codeOsLis)
      }
      if (this.$route.query.q) {
        this.filterLabels.push('OS ALVARO ' + this.$route.query.q)
      }
    },
    submitEventToAnalytics({ action, label }) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Resultados - Listagem',
        action: action,
        label: label
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';
@import '../../../static/stylesheets/components/orders/empty-cart';

.export-label {
  font-size: 11px;
  font-weight: 500;
  line-height: 2.18;
  letter-spacing: 1.8px;
  text-align: left;
  color: #ffffff;
}

.results-main-view {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  .results-list-bar {
    height: 75px;
    position: fixed;
    left: 0;
    background: #ebebeb;
    width: $contentContainerWidth;
    z-index: 2;
    display: inline-flex;

    .md-gutter-30 {
      &:not(.md-column) {
        margin-right: -15px;
        margin-left: -15px;

        > .md-layout {
          padding-right: 15px;
          padding-left: 15px;
        }
      }
    }

    &__button-container {
      flex-flow: row-reverse;
      display: flex;
      padding-top: 14px;
    }

    &__btn-export {
      width: 153px;
      outline: 0;

      &__icon {
        margin: 0 0 0 0;
        padding-right: 10px;
        width: 11px;
        height: 11px;
        min-height: 11px;
      }

      &:disabled {
        background-color: #d9d9d9;
        cursor: not-allowed;
      }
    }

    &__btn-receipt {
      width: 153px;
      margin-right: 20px;
      order: 1;

      &__icon {
        margin: 0 0 0 0;
        padding-right: 10px;
        width: 11px;
        height: 11px;
        min-height: 11px;
      }
    }
  }
}
</style>
